(function() {
    window.c24.lp.ac.hubRadio = {
        init: function() {
            window.c24.lp.ac.addDefaultQtips('hub_radio');
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.hubRadio.init();
    });

    const elements = document.querySelectorAll('.mod24ac.hub_radio .widget');

    for (let j = 0; j < elements.length; j++) {
        setTimeout(function() {
            new window.Vue({
                el: elements[j],
                data: {
                    bIsError: false,
                    oErrors: {
                        'noSelection': 'Es wurde nichts ausgewählt',
                        'generic': 'Es ist ein Fehler aufgetreten',
                    },
                    targetedFormId: '',
                    urlHash: '',
                    uniqueId: '',
                },
                mounted() {

                    window.c24LpInitializeFixables(this.$el.closest('.mod24ac'));

                    if (!window.c24LpIsMobile) {
                        window.c24.lp.ac.initGenericTooltips('hub_radio');
                    }

                    this.uniqueId = elements[j].dataset.uniqueId;
                    this.targetedFormId = elements[j].dataset.defaultTarget;
                    this.urlHash = this.hashCode(location.protocol + '//' + location.host + location.pathname);

                    if (window.c24LocalStorageGet(this.urlHash)) {
                        this.targetedFormId = window.c24LocalStorageGet(this.urlHash) + this.uniqueId;
                    }
                },
                methods: {
                    onChange: function(e) {
                        this.bIsError = false;

                        this.targetedFormId = e.target.value;

                        window.c24LocalStorageSet(this.urlHash, this.targetedFormId.replace(this.uniqueId,''));
                    },
                    submitForm: function(e) {
                        if (this.targetedFormId === '') {
                            this.fnThrowError('noSelection');
                        }

                        if (!this.bIsError) {
                            document.querySelector('#' + this.targetedFormId).submit();
                        }
                        e.preventDefault();

                        return false;
                    },
                    fnThrowError: function(sType) {
                        if (this.bIsError) {
                            return;
                        }

                        sType = (sType) ? sType : 'generic';

                        this.sErrorMsg = (this.oErrors[sType]) ? this.oErrors[sType] : this.oErrors.generic;

                        this.bIsError = true;
                    },
                    hashCode: function(string) {
                        let hash = 0;
                        if (string.length === 0) return hash;
                        for (let i = 0; i < string.length; i++) {
                            const char = string.charCodeAt(i);
                            hash = ((hash << 5) - hash) + char;
                            hash = hash & hash; // Convert to 32bit integer
                        }
                        return hash;
                    },
                },
            });
        }, 0);
    }
})();
